import { useState } from 'react'
import { inject, observer } from 'mobx-react'
import { useTheme } from '@emotion/react'

import { withRouterProps } from '../../../utils'
import { PiggyBank2Toggle, PalmTree } from '../../../assets/icons'
import {
  SVGWrapper,
  HelpIcon,
  TooltipText,
  SharedModal,
  FormError,
  Loading,
  Spacer,
} from '../../../components'
import { ModalActions, ModalConfirmButton } from '../../../components/ModalActions'
import {
  ToggleAndHelp,
  ToggleHelp,
  ToggleTrack,
  ToggleSegment,
  ModalText,
  OrangeText,
  BoldText,
} from './styles'

const SavingRetiredToggle = ({ navigate, store: { person, updatePerson, config } }) => {
  const theme = useTheme()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [status, setStatus] = useState('idle')

  const handleEnableSpending = async () => {
    try {
      setStatus('loading')
      if (person.retirementAge > person.age) {
        updatePerson({ retirementAge: person.age })
      }
      await config.enableSpendingMode()
      setIsModalOpen(false)
      // Switching modes can clear onboarding so the spend-down wizard can run.
      // Send the user there directly instead of flashing a dashboard they would
      // be bounced off of on their next visit to home.
      if (!config.onBoarded) {
        return navigate('/welcome/saving-or-spending', { replace: true })
      }
      return navigate('/spending')
    } catch (err) {
      console.error(err)
      setStatus('error')
    }
  }

  return (
    <>
      <ToggleAndHelp>
        <ToggleHelp>
          <HelpIcon size='medium' tooltip={TooltipText.homeToggle()} />
        </ToggleHelp>
        <ToggleTrack>
          <ToggleSegment active aria-label='saving'>
            <SVGWrapper
              svg={PiggyBank2Toggle}
              fill={theme.primaryColor}
              size='mediumLarge'
              cursor='pointer'
            />
            saving
          </ToggleSegment>
          <ToggleSegment onClick={() => setIsModalOpen(true)} aria-label='retired'>
            <SVGWrapper
              svg={PalmTree}
              fill={theme.lightestGray}
              size='mediumLarge'
              cursor='pointer'
            />
            retired
          </ToggleSegment>
        </ToggleTrack>
      </ToggleAndHelp>

      <SharedModal
        isModalOpen={isModalOpen}
        title='We just want to double check with you...'
        toggleModal={() => setIsModalOpen(open => !open)}
        isHeightRestricted={false}>
        <ModalText>
          <Spacer space='18px' />
          <p>
            Choosing “retired” means you are{' '}
            <OrangeText>
              retired, no longer accumulating savings for retirement and ready to withdraw money for
              retirement income
            </OrangeText>
          </p>
          <Spacer space='4px' />
          <p>
            <BoldText>This action cannot be undone. </BoldText>
            Be certain you are retired before selecting.
          </p>
        </ModalText>
        {status === 'error' && <FormError />}
        {status === 'loading' ? (
          <Loading />
        ) : (
          <ModalActions>
            <ModalConfirmButton type='button' onClick={handleEnableSpending}>
              I am retired
            </ModalConfirmButton>
          </ModalActions>
        )}
      </SharedModal>
    </>
  )
}

export default withRouterProps(inject('store')(observer(SavingRetiredToggle)))
